import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";
import RunButton from "TaskDialogCommon/RunButton";
import HeroObjectSelector from "TaskDialogCommon/HeroObjectSelector";
import TaskCheckBox from "TaskDialogCommon/TaskCheckBox";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import { getLastConfigForTask } from "Utils/Common";

const taskname = "heroupgrader";

const getInitialStatFromLastConfig = (accountdetailrow, AccountDetailData) => {
  const taskConfig = {
    accountdetail: accountdetailrow,
    selectedhero: null,
    unlockAllgemSlotsOnGear: false,
    upgradeAllGearToMaxUsingValtoRunes: false,
    upgradeAllSkillsOnHero: false,
    enahnceAllGearOnHeroUsingTitaniums: false,
    upgradeAssignedMountToMax: false,
    gemconfig: "None",
  };
  try {
    var storeddata = getLastConfigForTask(taskname);
    if (storeddata) {
      for (var key in AccountDetailData.heroes) {
        var cityObj = AccountDetailData.heroes[key];
        for (var hkey in cityObj.cityheroes) {
          var heroObj = cityObj.cityheroes[hkey];
          if (heroObj.heroname === storeddata.selectedhero.heroname) {
            taskConfig.selectedhero = heroObj;
          }
        }
      }
      taskConfig.unlockAllgemSlotsOnGear = storeddata.unlockAllgemSlotsOnGear;
      taskConfig.upgradeAllGearToMaxUsingValtoRunes =
        storeddata.upgradeAllGearToMaxUsingValtoRunes;
      taskConfig.upgradeAllSkillsOnHero = storeddata.upgradeAllSkillsOnHero;
      taskConfig.enahnceAllGearOnHeroUsingTitaniums =
        storeddata.enahnceAllGearOnHeroUsingTitaniums;
      taskConfig.upgradeAssignedMountToMax =
        storeddata.upgradeAssignedMountToMax;
      taskConfig.equipHeroWithBalancedDefence =
        storeddata.equipHeroWithBalancedDefence;
      taskConfig.equipHeroWithBalancedAtk = storeddata.equipHeroWithBalancedAtk;
    }
  } catch (e) {
    logger.log(e);
  }
  return taskConfig;
};

export default function(props) {
  const { AccountDetailData, accountdetailrow } = props;
  const [taskConfig, setTaskConfig] = React.useState(
    getInitialStatFromLastConfig(accountdetailrow, AccountDetailData)
  );

  const validate = () => {
    if (taskConfig.selectedhero === null) {
      alert("Please select a hero before continuing");
      return false;
    }
    return true;
  };

  const setValue = (event, key) => {
    let value = event.target.value;
    setTaskConfig({ ...taskConfig, [key]: value });
  };

  return (
    <TaskDialog heading={"Hero Upgrader"}>
      <HeroObjectSelector
        label={"Select Hero"}
        AccountDetailData={AccountDetailData}
        taskConfig={taskConfig}
        setValue={setValue}
        param={"selectedhero"}
      />

      <TaskCheckBox
        label={
          "Try ensure that all gem slots are unlocked on all gears on this hero using demount runes."
        }
        param={"unlockAllgemSlotsOnGear"}
        taskConfig={taskConfig}
        setValue={setValue}
      />

      <TaskCheckBox
        label={`Try ensure that all gears are upgraded to max level using
          Valto Runes.`}
        param={"upgradeAllGearToMaxUsingValtoRunes"}
        taskConfig={taskConfig}
        setValue={setValue}
      />

      <TaskCheckBox
        label={`Try ensure that all skills are level 10. Will auto unbox
          scrolls from inventory as needed.`}
        param={"upgradeAllSkillsOnHero"}
        taskConfig={taskConfig}
        setValue={setValue}
      />

      <TaskCheckBox
        label={`Try ensure that all are enhanced to max using Titanium
          charms. Will unbox Titanium Charms from inventory as needed.`}
        param={"enahnceAllGearOnHeroUsingTitaniums"}
        taskConfig={taskConfig}
        setValue={setValue}
      />

      <TaskCheckBox
        label={"Try ensure that mount if assigned is max level."}
        param={"upgradeAssignedMountToMax"}
        taskConfig={taskConfig}
        setValue={setValue}
      />

      <div>
        <FormControl component="fieldset" style={{ width: "100%" }}>
          <FormLabel component="legend">Gem Config to try embed:</FormLabel>
          <RadioGroup
            name="gemconfig"
            value={taskConfig.gemconfig}
            onChange={(event) => setValue(event, "gemconfig")}
          >
            <FormControlLabel
              value="None"
              control={<Radio />}
              label="None"
              style={{ width: "100%" }}
            />
            <FormControlLabel
              value="equipHeroWithBalancedDefence"
              control={<Radio />}
              label="Pure Def using free available gems in forge"
              style={{ width: "100%" }}
            />
            <FormControlLabel
              value="equipHeroWithBalancedAtk"
              control={<Radio />}
              label="Pure Attack using free available gems in forge"
              style={{ width: "100%" }}
            />
          </RadioGroup>
        </FormControl>
      </div>

      <RunButton
        taskname={taskname}
        taskConfig={taskConfig}
        label={"Run"}
        validate={validate}
      />
    </TaskDialog>
  );
}
